import { WidgetProps } from '@rjsf/utils';
import { useAppSelector } from '@/redux/hooks';
import { selectAllLanguages, selectBaseLanguages } from '@/redux/selectors/constantsSelectors';

const normalizeLanguageCode = (code?: string) => (code || '').replace('_', '-').toLowerCase();
const formatLanguageLabel = (label?: string, code?: string) => {
  const normalizedCode = normalizeLanguageCode(code);
  if (!label || !normalizedCode) return normalizedCode || label || '';
  return `${label} (${normalizedCode})`;
};

const MultiLanguagePickerWidget = (props: WidgetProps) => {
  const baseLanguages = useAppSelector(selectBaseLanguages);
  const allLanguages = useAppSelector(selectAllLanguages);
  const sourceLanguages = baseLanguages?.length ? baseLanguages : allLanguages;
  const languageMap = (sourceLanguages || []).reduce(
    (acc: Record<string, { label: string; is_short_list?: boolean }>, language) => {
      acc[normalizeLanguageCode(language.code)] = {
        label: language.label,
        is_short_list: language.is_short_list
      };
      return acc;
    },
    {}
  );

  const enumOptions = props.options?.enumOptions;
  const mappedEnumOptions = Array.isArray(enumOptions)
    ? enumOptions
        .map((option, index) => {
          const optionCode = String(option.value ?? '');
          const language = languageMap[normalizeLanguageCode(optionCode)];

          return {
            ...option,
            label: formatLanguageLabel(language?.label, optionCode),
            _isShortList: !!language?.is_short_list,
            _originalIndex: index
          };
        })
        .sort((a, b) => {
          if (a._isShortList === b._isShortList) {
            return a._originalIndex - b._originalIndex;
          }
          return a._isShortList ? -1 : 1;
        })
        .map(({ _isShortList, _originalIndex, ...option }) => option)
    : enumOptions;

  const SelectWidget = props.registry.widgets.SelectWidget;

  return (
    <SelectWidget
      {...props}
      options={{
        ...props.options,
        enumOptions: mappedEnumOptions
      }}
    />
  );
};

export default MultiLanguagePickerWidget;
